module.exports = __webpack_public_path__ + "static/media/icons_Bilan Epaule.768ae516.svg";